<template>
  <v-container fluid>
    <div class="wineLabelItemComponentForm">
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-layout row wrap>
          <v-flex xs12 class="text-xs-center text-sm-center text-md-center text-lg-center">
          <img :src="imageUrl" height="150" v-if="imageUrl"/>
          <v-text-field label="Izaberi sliku" @click='pickFile' v-model='imageName' prepend-icon='attach_file'></v-text-field>
          <input
            type="file"
            style="display: none"
            ref="image"
            accept="image/*"
            @change="onFilePicked"
          >
        </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex xs12>
            <v-btn @click="uploadPicture" class="AppButtonFilled" :disabled="imageUrl===''"
              >Dodaj sliku</v-btn
            >
          </v-flex>
        </v-layout>
        <!-- /.Action buttons -->
      </v-form>
      <TokenComponent ref="frmtoken" />
    </div>
  </v-container>
</template>

<script>
import { serverBus } from "../main";
import { readJSON } from "../helpers/Functions";
import TokenComponent from "../components/Token";

export default {
  props: ["item"],
  name: "WineLabelItem",
  components: {
    TokenComponent,
  },
  data: () => ({
    autoGrowHack: false,
    valid: true,
    ID: "0",
    naziv:"",
    title: "Image Upload",
    // dialog: false,
    imageName: '',
    imageUrl: '',
    imageFile: ''
  }),
  watch: {
    item: function (val) {
      if (val !== undefined) {
        // console.log(val);

        

        this.ID = val.id;
        this.naziv = val.name;
      }
    },
  },
  methods: {
    pickFile() {
      this.$refs.image.click()
    },
    isNumber(e) {
      e = e || window.event;
      var charCode = (typeof e.which == "undefined") ? e.keyCode : e.which;
      var charStr = String.fromCharCode(charCode);

      

      if (!charStr.match(/^[0-9]+$/))
      e.preventDefault();
      return true;
    },
    onFilePicked(e) {
      const files = e.target.files
      if (files[0] !== undefined) {
        this.imageName = files[0].name
        if (this.imageName.lastIndexOf('.') <= 0) {
          return
        }
        const fr = new FileReader()
        fr.readAsDataURL(files[0])
        fr.addEventListener('load', () => {
          this.imageUrl = fr.result
          this.imageFile = files[0] // this is an image file that can be sent to server...

          // console.log(this.imageUrl);
          // console.log(this.imageFile);
        })
      } else {
        this.imageName = ''
        this.imageFile = ''
        this.imageUrl = ''
      }
    },
    uploadPicture() {
      // var data = new FormData();
      // data.append('file', this.imageFile);

      var complexObject = {
        base64: this.imageUrl.split(",")[1]
        };

      this.$http
        .post(
          this.globalServiceLocation +
            this.globalPort +
            "/wine_label/" + this.ID + "/upload",
            complexObject,
          {
            headers: {
              
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          alert("Slika za etiketu " + this.naziv + " je uspešno dodata.");
          this.$emit("newdata", null);
        })
        .catch((e) => {
          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  this.$http
                    .post(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/wine_label/" + this.ID + "/upload",
                      complexObject,
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      alert("Slika za etiketu " + this.naziv + " je uspešno dodata.");
                      this.$emit("newdata", null);
                    })
                    .catch((e) => {
                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    }
  },
  mounted() {
    serverBus.$on("applied_wine_label", (item) => {
      //alert(item.name);
      this.ID = item.id;
    });
  },
};
</script>
    
<style lang="scss" scoped>
@import "./../assets/sass/parts/modalStyles";
@import "../assets/sass/parts/_tanksRoom.scss";

.VineYear {
  margin-top: 0px;
  margin-bottom: 80px;
  &__Header {
    display: flex;
    padding: 4px 15px 0;
    justify-content: space-between;
    h2 {
      font-family: NunitoSans, sans-serif;
      font-size: 32px;
      letter-spacing: 0;
      font-weight: 300;
      // text-transform: uppercase;
      color: #000;
    }
    .more_info {
      color: #fff;
      border: solid 1px;
      margin-top: 6px;
    }
    &--crveno {
      background-color: #8e302f;
      h2 {
        color: #ffffff;
      }
      .more_info {
        color: #ffffff;
        border-color: #fff;
      }
    }
    &--belo {
      background-color: #fcf5e2;

      h2 {
        color: #d30031;
      }
      .more_info {
        border-color: #d30031;
      }
    }
    &--penusavo {
      background-color: #d8d5cb;

      h2 {
        color: #d30031;
      }
      .more_info {
        border-color: #d30031;
      }
    }
    &--rose {
      background-color: #ffcbc4;

      h2 {
        color: #d30031;
      }
      .more_info {
        border-color: #d30031;
      }
    }
    &--pojacano {
      background-color: #892b23;

      h2 {
        color: #ffffff;
      }
      .more_info {
        color: #ffffff;
        border-color: #fff;
      }
    }
    &--slatko {
      background-color: #fcc862;

      h2 {
        color: #d30031;
      }
      .more_info {
        border-color: #d30031;
      }
    }
  }

  &__Content {
    display: flex;
    flex-wrap: wrap;
    &__Vine {
      display: flex;
      // margin-right: 30px;
      .VineBox {
        margin-right: 15px;
      }
      .VineYears {
        max-width: 120px;
        height: 100%;
        max-height: 310px;
        margin: -3px -3px -3px -3px;
        display: inline-flex;
        flex-wrap: wrap;
        flex-direction: column;
        justify-content: flex-start;
        span {
          display: block;
          width: 63px;
          height: 33px;
          padding-top: 2px;
          margin: 3px;
          // border-radius: 6px;
          // border: solid 1px #9b9b9b;
          font-family: NunitoSans, sans-serif;
          font-size: 18px;
          font-weight: bold;
          letter-spacing: 0;
          text-align: center;
          color: #000000;
        }
      }
    }
  }
}
.Description textarea {
  height: 40px;
}

div.v-input.Description.v-textarea.v-text-field {
  margin-top: 0px;
}

div.flex.pa-2 {
  padding-bottom: 0px !important;
  padding-top: 0px !important;
}

.TankDetails {
  display: flex;
  padding: 0 10px;
  flex-direction: column;
  // border-left: 1px solid #979797;
  width: 100%;
  @include bp(_1200) {
    padding: 0 10px;
  }
  &__Item {
    > * {
      width: 30%;
      display: inline-block;
      vertical-align: middle;
    }
    margin-bottom: 4px;
    font-family: "NunitoSans", sans-serif;
    font-size: 16px;
    .label {
      width: 130px;
      letter-spacing: 0;
      color: #9b9b9b;
      margin-right: 10px;
      text-align: right;
      @include bp(_1200) {
        width: auto;
      }
    }
    .value {
      width: 50%;
      color: #000;
    }
    .maka {
      max-width: 200px;
      letter-spacing: 0;
      color: #9b9b9b;
      margin-right: 20px;
      @include bp(_1200) {
        width: auto;
      }
    }
    .kvaka {
      max-width: 45px;
      letter-spacing: 0;
      color: #9b9b9b;
      margin-right: 20px;
      @include bp(_1200) {
        width: auto;
      }
    }
  }
}
</style>
